import React, { useEffect, useState } from "react";
import {
  useAccessAccountAndTeamQuery,
  useContactDynamicFieldQuery,
  useContactsInfoDetailsQuery,
  useDeleteContactsAttachmentMutation,
  useUpdateContactInfoDetailsMutation,
} from "../../../Services/customer/FrontendCustomer";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import "./styles.scss";
import {
  useTagsQuery,
  useTeamsQuery,
} from "../../../Services/settingsAPIs/CommonAPI";
import { toast } from "react-toastify";
import {
  Box,
  IconButton,
  Typography,
  Modal,
  Tooltip,
  Chip,
  Button,
} from "@mui/material";
import { GridCloseIcon } from "@mui/x-data-grid";
import ContactCustomerHistory from "./ContactCustomerHistory";
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";
import { isFieldDisabled } from "../../reusableComponent/FieldDisabled";
import { useTelephony } from "../../context/TelephonyContext";
import InfoIcon from "@mui/icons-material/Info";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import AttachmentList from "../../user/AttachmentList";
import { getCustomerPermission } from "../../../pages/contact/CustomerPermissions";
import { Loader } from "react-bootstrap-typeahead";
import { MultiLevelDropdown } from "../../MultiLevelDropdown";
import MuiPhone from "../../../pages/campaign/MuiPhone";

function getFullPathForDropdown(field: any, lastValue: string | null | undefined): string | null {
  if (!lastValue || !field?.multiple_level) return lastValue || null;
  // BFS or DFS to find the path
  const stack: { node: any; path: string[] }[] = field.multiple_level.map((node: any) => ({ node, path: [node.choice] }));
  while (stack.length > 0) {
    const { node, path } = stack.pop();
    if (node.choice === lastValue) {
      return path.join(' > ');
    }
    // check for next levels
    Object.keys(node).forEach((k) => {
      if (k.startsWith('level') && Array.isArray(node[k])) {
        node[k].forEach((child: any) => {
          stack.push({ node: child, path: [...path, child.choice] });
        });
      }
    });
  }
  return lastValue; // fallback
}

interface UserDetails {
  id: number | null;
  name: string;
  email: string;
  phone_number: any;
  account: { name?: string };
  whatsapp_number: string;
  twitter_id: any;
  facebook_id: any;
  customer_id: any;
}
interface Tag {
  id: string;
  name: string;
}

interface Team {
  id: string;
  name: string;
}

interface ErrorState {
  [key: string]: string;
}
interface RestItems {
  accessible_teams: Array<any>;
  tags: Array<any>;
  name: any;
  account: { name?: string };
  email: any;
  phone_number: any;
  twitter_id: any;
  facebook_id: any;
  customer_id: any;
  attachments: [];
}

const initialRestItems: RestItems = {
  accessible_teams: [],
  tags: [],
  name: "",
  account: { name: "" },
  email: "",
  phone_number: "",
  twitter_id: "",
  facebook_id: "",

  customer_id: "",
  attachments: [],
};

const ContactInfo = () => {
  const { id } = useParams();
  const { storingContactData } = useTelephony();

  const location = useLocation();
  const userId = location.state as UserDetails;

  type NavigationState = {
    contactData?: {
      name: string;
      email: string;
      mobile: string;
    };
    showAccountButton?: boolean;
  };

  const { contactData, showAccountButton } =
    (location.state as NavigationState) || {};
  const [dynamicFields, setDynamicFields] = useState({});
  const [initialDynamicFields, setInitialDynamicFields] = useState({});
  const [attachments, setAttachments] = useState([]);
  const [files, setFiles] = useState([]);

  const [restItems, setRestItems] = useState<RestItems>(initialRestItems);

  const [getUserData, setGetUserData] = useState<UserDetails>({
    id: null,
    name: "",
    email: "",
    phone_number: "",
    account: {},
    whatsapp_number: "",
    twitter_id: "",
    facebook_id: "",
    customer_id: "",
  });

  const [accountName, setAccountName] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [whatsapp, setWhatsapp] = useState<any>("");
  const [twitter, setTwitter] = useState("");
  const [facebook, setFacebook] = useState("");
  const [tagsData, setTagsData] = useState([]);
  const [customerId, setCustomerId] = useState("");
  const [selectedTeams, setSelectedTeams] = useState([]);
  const [selectedTags, setSelectedTags] = useState<string[]>([]);
  const [errors, setErrors] = useState<any>({});
  const [isSomethingAdded, setIsSomethingAdded] = useState(false);
  const [teamAdded, setTeamAdded] = useState([]);
  const [phoneCountry, setPhoneCountry] = useState("IN");

  const [isContactCustomerHistoryVisible, setIsContactCustomerHistoryVisible] =
    useState(false);
  const [teamAndAccountData, setTeamAndAccountData] = useState([]);
  const [accountSelected, setAccountSelected] = useState<any>("");
  const [accessibleTeams, setAccessibleTeams] = useState([]);
  const [accountLoading, setAccountLoading] = useState<boolean>(false);

  const [requiredFields, setRequiredFields] = useState<Set<string>>(new Set());

  const isAdmin = localStorage.getItem("user_role");

  const { data, refetch } = useContactsInfoDetailsQuery(id);
  const { data: tags } = useTagsQuery({});
  const { data: teams } = useTeamsQuery({});
  const [trigger] = useUpdateContactInfoDetailsMutation();
  const { data: teamAndAccount, status: teamAndAccountStatus } =
    useAccessAccountAndTeamQuery({});

  const { data: dynamicData } = useContactDynamicFieldQuery({});
  const [deleteAttachTrigger] = useDeleteContactsAttachmentMutation();

  // Initialize state from backend data first
  useEffect(() => {
    if (data) {
      setRestItems(data as RestItems);

      // Set basic contact info from backend data
      setName(data.name || "");
      setEmail(data.email || "");
      setMobile(data.phone_number || "");
      setWhatsapp(data.whatsapp_number || "");
      setTwitter(data.twitter_id || "");
      setFacebook(data.facebook_id || "");
      setCustomerId(data.customer_id || "");
      setAccountSelected(data?.account?.id || "");

      // Set dynamic fields from backend data
      if (data?.dynamic_fields) {
        setDynamicFields(data.dynamic_fields);
        setInitialDynamicFields(data.dynamic_fields);
      }

      // Set attachments from backend data
      if (data?.attachments) {
        setAttachments(data.attachments);
      }
    }
  }, [data]);

  // Override with location state data if available (from navigation)
  useEffect(() => {
    if (userId) {
      setGetUserData(userId);
      setEmail(userId?.email);
      setName(userId?.name);
      setMobile(userId?.phone_number);
      setAccountName(userId?.account?.name);
      setWhatsapp(userId?.whatsapp_number);
      setCustomerId(userId?.customer_id);
    }
  }, [userId]);

  useEffect(() => {
    if (tags) {
      setTagsData(tags);
    }
  }, [tags]);

  useEffect(() => {
    if (teams) {
      setSelectedTeams(teams);
    }
  }, [teams]);

  useEffect(() => {
    if (dynamicData) {
      // Create a set of required field labels
      const requiredFieldLabels = dynamicData
        .filter((field) => field.is_required)
        .map((field) => field.label);
      setRequiredFields(new Set(requiredFieldLabels));
    }
  }, [dynamicData]);

  useEffect(() => {
    if (teamAndAccount) {
      setTeamAndAccountData(teamAndAccount);
    }
  }, [teamAndAccount]);

  useEffect(() => {
    if (teamAndAccountStatus === "pending") {
      setAccountLoading(true);
    } else {
      setAccountLoading(false);
    }
  }, [teamAndAccountStatus]);

  const tagSelectHandler = (tags: any) => {
    setIsSomethingAdded(true);

    setRestItems((prevState) => {
      const tagExists = prevState.tags.some((tag) => tag.id === tags.id);

      if (tagExists) {
        // If the selected tag already exists, remove it (clear the selection)
        return {
          ...prevState,
          tags: [],
        };
      } else {
        const newTag: Tag = { id: tags.id, name: tags?.name }; // Adjust based on your actual tag data
        return {
          ...prevState,
          tags: [newTag], // Keep only the new tag
        };
      }
    });
  };

  const handleTeamClick = (teamDetails: Team) => {
    setIsSomethingAdded(true);

    setRestItems((prevState) => {
      const teamExists = prevState.accessible_teams.some(
        (team) => team.id === teamDetails.id
      );

      if (teamExists) {
        return {
          ...prevState,
          accessible_teams: prevState.accessible_teams.filter(
            (team) => team.id !== teamDetails.id
          ),
        };
      } else {
        return {
          ...prevState,
          accessible_teams: [...prevState.accessible_teams, teamDetails],
        };
      }
    });
  };

  const isEditContactDetailsEnabled =
    localStorage.getItem("isEditContactDetailsEnable") === "true"
      ? true
      : false;

  const initialTeamIds = restItems.accessible_teams.map((team) => team.id);
  const mergedTeams = Array.from(new Set([...initialTeamIds, ...teamAdded]));

  const initialTagIds = restItems.tags.map((tags) => tags.id);
  const mergedTags = Array.from(new Set([...initialTagIds, ...selectedTags]));

  const handleEmailChange = (e) => {
    const value = e.target.value;
    setEmail(value);
    setIsSomethingAdded(true);

    // Validate email format if a value exists
    setErrors((prevErrors) => {
      const newErrors = { ...prevErrors };

      // Clear previous error
      delete newErrors.mainEmail;

      if (value) {
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!emailRegex.test(value)) {
          newErrors.mainEmail = "Invalid email format";
        }
      }

      return newErrors;
    });
  };

  // Function to handle input changes in dynamic fields
  const handleInputChange = (key: string, value: any) => {
    // Find the field definition to check if it's an email field
    const field = dynamicData.find((f) => f.label === key);

    // Update errors state
    setErrors((prevErrors) => {
      const newErrors = { ...prevErrors };

      // Clear previous error for this field
      delete newErrors[key];

      // For email fields, validate the format if a value exists
      if (field?.field_type === "email" && value) {
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!emailRegex.test(value)) {
          newErrors[key] = "Invalid email format";
        }
      }

      return newErrors;
    });

    // Update the dynamic fields state
    setDynamicFields((prevState) => ({
      ...prevState,
      [key]: value,
    }));

    setIsSomethingAdded(true);
  };

  const validateForm = () => {
    const newErrors: ErrorState = {};

    // Validate all dynamic fields
    dynamicData.forEach((field: any) => {
      const fieldValue = dynamicFields[field.label];
      const fieldKey = field.label;

      // Required field validations (unchanged)
      if (field.is_required && !fieldValue) {
        newErrors[fieldKey] = `${fieldKey} is required`;
      }

      if (
        field.is_required &&
        field.field_type === "drop-down" &&
        !fieldValue
      ) {
        newErrors[fieldKey] = `${fieldKey} is required`;
      }

      if (
        field.is_required &&
        field.field_type === "check-box" &&
        !fieldValue
      ) {
        newErrors[fieldKey] = `${fieldKey} is required`;
      }

      // Phone validation (unchanged)
      if (field.is_required && field.field_type === "tel-phone" && fieldValue) {
        const isValidPhone =
          /^(?:\+?\d{1,3})?[ -]?\(?\d{1,4}?\)?[ -]?\d{1,4}[ -]?\d{1,4}(?: x\d{1,4})?$/.test(
            fieldValue
          );
        if (!isValidPhone) {
          newErrors[fieldKey] = `${fieldKey} must be a valid phone number`;
        }
      }

      // Email validation for ALL email fields, whether required or not
      if (field.field_type === "email" && fieldValue) {
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!emailRegex.test(fieldValue)) {
          newErrors[fieldKey] = `Invalid email format`;
        }
      }
    });

    // Validate the main email field if it has content
    if (email) {
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!emailRegex.test(email.trim())) {
        newErrors.mainEmail = "Invalid email address";
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const saveButtonHandler = async (e) => {
    e.preventDefault();

    // Use validateForm to check all validations including email fields
    const isFormValid = validateForm();

    if (!isFormValid) {
      // Get the first error message to display
      const errorMessages = Object.values(errors);
      const firstErrorMessage =
        errorMessages.length > 0
          ? errorMessages[0]
          : "Please fix the validation errors before saving.";
      toast.error(firstErrorMessage);
      return;
    }

    // Prepare all dynamic fields for submission
    // Changed to send all dynamic fields, not just edited ones
    const allDynamicFields = Object.keys(dynamicFields).reduce((acc, key) => {
      const field = dynamicData.find((field) => field.label === key);

      // Only include fields that the user can edit based on role
      const isFieldEditableForRole = isAdmin === "admin" || field?.is_editable;

      if (isFieldEditableForRole) {
        const currentFieldValue = dynamicFields[key];

        if (field?.field_type === "date" && currentFieldValue) {
          const formattedDate = new Date(currentFieldValue)
            .toISOString()
            .replace("Z", "+00:00");
          acc[key] = formattedDate;
        } else {
          acc[key] = currentFieldValue;
        }
      }

      return acc;
    }, {});

    const contactInfoObj = {
      accessible_teams: mergedTeams,
      dynamic_fields: allDynamicFields,
      email: email,
      facebook_id: facebook,
      name: name,
      phone_number: mobile,
      tags: mergedTags,
      twitter_id: twitter,
      whatsapp_number: whatsapp,
      attachments: attachments?.filter((att) => !att.id),
      account: accountSelected,
    };

    try {
      const response = await trigger({ body: contactInfoObj, id: id });
      if (response?.data) {
        toast.success("Edited successfully");
        setIsSomethingAdded(false);
        setFiles([]);

        // Update local state with the new values to ensure consistency
        setInitialDynamicFields({ ...dynamicFields });

        // Update the complete data
        refetch();
      } else if (response && "error" in response) {
        const errorData = response.error as any;

        // Handle specific field errors
        if (errorData.data) {
          // Check if it's a validation error object with field-specific errors
          if (
            typeof errorData.data === "object" &&
            !Array.isArray(errorData.data)
          ) {
            // Handle email error specifically
            if (errorData.data.email && Array.isArray(errorData.data.email)) {
              const emailError = errorData.data.email[0];
              toast.error(emailError);
              return;
            }

            // Handle other field errors
            const firstFieldError = Object.keys(errorData.data)[0];
            if (
              firstFieldError &&
              Array.isArray(errorData.data[firstFieldError])
            ) {
              const errorMessage = errorData.data[firstFieldError][0];
              toast.error(errorMessage);
              return;
            }
          }

          // Handle general error array
          if (errorData.data.error && Array.isArray(errorData.data.error)) {
            toast.error(errorData.data.error[0] || "An error occurred.");
            return;
          }
        }

        // Fallback error message
        toast.error("An error occurred while updating the contact.");
      }
    } catch (error) {
      console.error("Error updating contact:", error);
      toast.error("Unable to edit contact. Please try again.");
    }
  };
  const capitalizeFirstLetter = (string: any) => {
    return (
      string &&
      string?.charAt &&
      string?.charAt(0)?.toUpperCase() + string.slice(1)
    );
  };

  const handleDropdownChange = (key, value) => {
    setDynamicFields((prevFields) => ({
      ...prevFields,
      [key]: value,
    }));
    setIsSomethingAdded(true);
  };

  const getDataTimeFormatted = (date) => {
    if (date && date.length > 0) {
      const dateObj = new Date(date);

      const year = dateObj.getUTCFullYear();
      const month = String(dateObj.getUTCMonth() + 1).padStart(2, "0"); // Months are zero-based
      const day = String(dateObj.getUTCDate()).padStart(2, "0");
      const hours = String(dateObj.getUTCHours()).padStart(2, "0");
      const minutes = String(dateObj.getUTCMinutes()).padStart(2, "0");

      return `${year}-${month}-${day}T${hours}:${minutes}`;
    }
    return "";
  };

  // Function to get current date-time formatted as 'YYYY-MM-DDTHH:mm'
  const getCurrentDateTimeFormatted = () => {
    const now = new Date();

    const year = now.getUTCFullYear();
    const month = String(now.getUTCMonth() + 1).padStart(2, "0");
    const day = String(now.getUTCDate()).padStart(2, "0");
    const hours = String(now.getUTCHours()).padStart(2, "0");
    const minutes = String(now.getUTCMinutes()).padStart(2, "0");

    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };

  const openContactCustomerHistoryModal = () => {
    setIsContactCustomerHistoryVisible(true);
  };

  const closeContactCustomerHistoryModal = () => {
    setIsContactCustomerHistoryVisible(false);
  };

  const style2 = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "90%",
    maxWidth: "1200px",
    height: "80%",
    overflow: "hidden",
    bgcolor: "background.paper",
    border: "1px solid white",
    boxShadow: 24,
    p: 4,
    borderRadius: 2,
  };

  const handleWhatsappChange = (value: string | undefined) => {
    if (!value) return;

    setWhatsapp(value);
    setIsSomethingAdded(true);
  };

  const handleMobileNumberChange = (value: string | undefined) => {
    if (!value) return;
    setMobile(value);
    setIsSomethingAdded(true);
  };

  const navigate = useNavigate();
  const handleBackButtonClick = () => {
    navigate(-1); // Navigate back to the previous page
  };

  const handleDelete = async (id) => {
    const attId = {
      attachment_id: id,
    };
    const response = await deleteAttachTrigger(attId);

    if (response?.data) {
      setAttachments((prevAttachments) =>
        prevAttachments.filter((attachment) => attachment.id !== id)
      );
    } else {
      toast.error("Unable to delete an attachment");
    }
  };

  const handleDeleteFile = (fileToDelete) => () => {
    setAttachments((prevFiles) =>
      prevFiles.filter((file) => file !== fileToDelete)
    );
  };

  const handleFileChange = async (event) => {
    const newFiles = Array.from(event.target.files);
    const filePromises = newFiles?.map((file: any) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e: any) => {
          const fileData = {
            file_name: file.name,
            file: e.target.result.split(",")[1], // Extracting Base64 part
          };
          resolve(fileData);
        };
        reader.onerror = (error) => reject(error);
        reader.readAsDataURL(file);
      });
    });

    try {
      const fileDataArray = await Promise.all(filePromises);
      setAttachments((prevFiles) => [...prevFiles, ...fileDataArray]);
      setFiles((prevFiles) => [...prevFiles, ...fileDataArray]);
      setIsSomethingAdded(true);
    } catch (error) {
      console.error("Error reading files:", error);
      toast.error("An error occurred while uploading files. Please try again.");
    }
  };

  const accountSelectHandler = (event) => {
    const selectedAccountId = event.target.value;
    setAccountSelected(selectedAccountId);

    const selectedAccount = teamAndAccountData.find(
      (acc) => acc.id === parseInt(selectedAccountId)
    );
    setIsSomethingAdded(true);
    setAccessibleTeams(selectedAccount ? selectedAccount.accessible_teams : []);
  };

  // Function to update name field
  const handleNameChange = (e) => {
    const value = e.target.value;
    setName(value);
    setIsSomethingAdded(true);
  };

  // Function to update twitter field
  const handleTwitterChange = (e) => {
    const value = e.target.value;
    setTwitter(value);
    setIsSomethingAdded(true);
  };

  // Function to update facebook field
  const handleFacebookChange = (e) => {
    const value = e.target.value;
    setFacebook(value);
    setIsSomethingAdded(true);
  };

  return (
    <div className="cont responsive-container" style={{ padding: "20px 10px" }}>
      <div 
        className="header-section"
        style={{ 
          display: "flex", 
          justifyContent: "space-between",
        }}
      >
        <div className="">
          <button
            style={{ marginLeft: "20px" }}
            className="btn btn-link mb-2"
            onClick={handleBackButtonClick}
          >
            <i
              data-toggle="tooltip"
              data-placement="top"
              title="Back"
              className="bi bi-arrow-90deg-left"
              style={{
                fontSize: "20px",
                color: "black",
                cursor: "pointer",
              }}
            ></i>
          </button>
        </div>
        <div style={{ width: "95%", textAlign: "center" }}>
          <h3>Edit contact</h3>
        </div>
        <span
          style={{
            flex: "1",
            gap: "10px",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <button
            className="text-hover-primary border-0 me-4"
            style={{ background: "transparent" }}
            onClick={openContactCustomerHistoryModal}
          >
            <i
              data-placement="top"
              title="Customer History"
              className="bi bi-file-earmark-spreadsheet text-dark fs-2"
              style={{
                cursor: "pointer",
              }}
            ></i>
          </button>
        </span>
      </div>

        <div className="contact_info-cont responsive-contact-grid" style={{ paddingTop: "0", gridTemplateColumns: "repeat(auto-fit, minmax(350px, 1fr))", }}>
        <div className="account">
          <label>Customer Id</label>
          <input
            disabled={!isEditContactDetailsEnabled}
            className="form-control"
            value={customerId}
          />
        </div>
        <div className="account">
          <label>Account name</label>
          {accountLoading ? (
            <div className="mt-2">
              <Loader />
            </div>
          ) : (
            <select
              disabled={!isEditContactDetailsEnabled}
              onChange={accountSelectHandler}
              value={accountSelected}
              // make sure to define this setter
              className="form-control"
            >
              <option value="">Select Account</option>
              {teamAndAccountData?.map((acc) => (
                <option value={acc.id} key={acc.id}>
                  {acc.name}
                </option>
              ))}
            </select>
          )}
        </div>

        <div className="account">
          <label className={requiredFields.has("name") ? "required" : ""}>
            Name
          </label>
          <input
            disabled={!isEditContactDetailsEnabled}
            className={`form-control ${
              requiredFields.has("name") ? "is-invalid" : ""
            }`}
            value={name}
            onChange={handleNameChange}
          />
        </div>
        <div className="account">
          <label className={requiredFields.has("email") ? "required" : ""}>
            Email
          </label>
          <input
            disabled={!isEditContactDetailsEnabled}
            className={`form-control ${
              requiredFields.has("email") || errors.mainEmail
                ? "is-invalid"
                : ""
            }`}
            value={email}
            onChange={handleEmailChange}
          />
          {errors.mainEmail && (
            <div style={{ color: "red" }}>{errors.mainEmail}</div>
          )}
        </div>

        <div className="account" style={{ position: "relative", zIndex: 100 }}>
          <label
            className={requiredFields.has("phone_number") ? "required" : ""}
          >
            Mobile no
          </label>
          <MuiPhone
            style={{ width: "100%" }}
            disabled={!isEditContactDetailsEnabled}
            value={mobile || "+91"}
            onChange={handleMobileNumberChange}
            phoneCountry={phoneCountry}
            onCountryChange={setPhoneCountry}
          />
        </div>
        <div className="account" style={{ position: "relative", zIndex: 100 }}>
          <label>WhatsApp no</label>
          <MuiPhone
            style={{ width: "100%" }}
            disabled={!isEditContactDetailsEnabled}
            value={whatsapp || "+91"}
            onChange={handleWhatsappChange}
            phoneCountry={phoneCountry}
            onCountryChange={setPhoneCountry}
          />
        </div>
        <div className="account">
          <label>Twitter Id</label>
          <input
            disabled={!isEditContactDetailsEnabled}
            className="form-control"
            onChange={handleTwitterChange}
            value={twitter}
          />
        </div>
        <div className="account">
          <label>Facebook id</label>
          <input
            disabled={!isEditContactDetailsEnabled}
            className="form-control"
            onChange={handleFacebookChange}
            value={facebook}
          />
        </div>
      </div>

      <div>
        <div
          className="dynamic-fields-grid"
          style={{
            display: "grid",
            gap: "50px",
            padding: "0 20px",
            gridTemplateColumns: "repeat(auto-fit, minmax(350px, 1fr))",
          }}
        >
          {dynamicData?.length > 0 &&
            dynamicData.map((field: any) => {
              const { id, field_type, label, choices } = field || {};
              const fieldKey = label || "";

              // Skip rendering if required properties are missing
              if (!id || !field_type || !label) return null;

              if (field_type === "drop-down") {
                return (
                  <div key={id} className="dynamic-field">
                    <label
                      className={
                        requiredFields && requiredFields.has(fieldKey)
                          ? "required"
                          : ""
                      }
                    >
                      {capitalizeFirstLetter(fieldKey)}
                    </label>
                    <select
                      disabled={
                        !isEditContactDetailsEnabled ||
                        isFieldDisabled(field?.is_editable)
                      }
                      // disabled
                      className="form-control"
                      value={dynamicFields[fieldKey] || ""}
                      onChange={(e) =>
                        handleDropdownChange(fieldKey, e.target.value)
                      }
                    >
                      <option value="">Select an option</option>
                      {choices?.map((choice: any) => (
                        <option key={choice?.id} value={choice?.choice}>
                          {choice?.choice}
                        </option>
                      ))}
                    </select>
                    {errors[fieldKey] && (
                      <div style={{ color: "red" }}>{errors[fieldKey]}</div>
                    )}
                  </div>
                );
              } else if (field_type === "multi-level") {
                return (
                  <MultiLevelDropdown
                    field={field}
                    value={getFullPathForDropdown(field, dynamicFields[field.label])}
                    onFinalSelect={(lastChoice,fullPath) => {
                       setDynamicFields((prev) => ({
                        ...prev,
                        [field.label]: fullPath || lastChoice.choice // Store only the last value
                      }));
                      // Clear error when a value is selected
                          if (errors[fieldKey]) {
                            setErrors(prev => {
                              const newErrors = { ...prev };
                              delete newErrors[fieldKey];
                              return newErrors;
                            });
                          }
                    }}
                    error={errors[fieldKey]}
                  />
                );
              } else if (field_type === "tel-phone") {
                return (
                  <div key={id} className="dynamic-field">
                    <label
                      className={
                        requiredFields && requiredFields.has(fieldKey)
                          ? "required"
                          : ""
                      }
                    >
                      {capitalizeFirstLetter(fieldKey)}
                    </label>
                    <div
                      className="telephone-field"
                      style={{
                        display: "flex",
                        width: "100%",
                      }}
                    >
                      <MuiPhone
                        disabled={
                          !isEditContactDetailsEnabled ||
                          isFieldDisabled(field?.is_editable)
                        }
                        value={dynamicFields[fieldKey] || "+91"}
                        onChange={(phone: string) =>
                          handleInputChange(fieldKey, phone)
                        }
                        phoneCountry={phoneCountry}
                        onCountryChange={setPhoneCountry}
                      />
                    </div>
                    {errors[fieldKey] && (
                      <div style={{ color: "red" }}>{errors[fieldKey]}</div>
                    )}
                  </div>
                );
              } else if (field_type === "date-time") {
                return (
                  <div>
                    <label
                      className={requiredFields.has(fieldKey) ? "required" : ""}
                    >
                      {capitalizeFirstLetter(fieldKey)}
                    </label>

                    <input
                      disabled={
                        !isEditContactDetailsEnabled ||
                        isFieldDisabled(field?.is_editable)
                      }
                      className="form-control"
                      max={getCurrentDateTimeFormatted()} // Restrict to current date-time
                      value={getDataTimeFormatted(dynamicFields[fieldKey])}
                      type={field_type === "date-time" ? "datetime-local" : ""}
                      placeholder=""
                      onChange={(e) =>
                        handleInputChange(fieldKey, e.target.value)
                      }
                    />
                  </div>
                );
              } else {
                return (
                  <div key={id} className="dynamic-field">
                    <label
                      className={
                        requiredFields && requiredFields.has(fieldKey)
                          ? "required"
                          : ""
                      }
                    >
                      {capitalizeFirstLetter(fieldKey)}
                    </label>
                    <input
                      className="form-control"
                      disabled={
                        !isEditContactDetailsEnabled ||
                        isFieldDisabled(field?.is_editable)
                      }
                      type={
                        field?.is_masked
                          ? "text"
                          : field_type === "date"
                          ? "datetime-local"
                          : field_type === "email"
                          ? "email"
                          : field_type === "number"
                          ? "number"
                          : "text"
                      }
                      placeholder={
                        field_type === "email"
                          ? "Enter your email"
                          : field_type === "number"
                          ? "Number"
                          : ""
                      }
                      value={dynamicFields[fieldKey] || ""}
                      onChange={(e) =>
                        handleInputChange(fieldKey, e.target.value)
                      }
                    />
                    {errors[fieldKey] && (
                      <div style={{ color: "red" }}>{errors[fieldKey]}</div>
                    )}
                  </div>
                );
              }
            })}
        </div>
      </div>

      <div className="tags_teams-combo">
        {tagsData?.length > 0 && (
          <div className="tags_cont" style={{ padding: "0 20px" }}>
            <h4 className="heading">Tags</h4>
            <div className="tags_name responsive-tags-container" style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
              {tagsData?.length > 0 &&
                tagsData?.map((tags) => (
                  <p
                    onClick={() => tagSelectHandler(tags)}
                    key={tags?.id}
                    style={{
                      borderRadius: "50px",
                      padding: "7px 15px",
                      whiteSpace: "nowrap",
                      background:
                        restItems?.tags?.find((t) => t?.id === tags?.id) ||
                        selectedTags.includes(tags?.id)
                          ? "rgb(141 146 149)"
                          : "white",

                      border:
                        restItems?.tags?.find((t) => t?.id === tags?.id) ||
                        selectedTags.includes(teams.id)
                          ? "none"
                          : "1px solid rgb(211 211 211)",
                      color:
                        restItems?.tags?.find((t) => t?.id === tags?.id) ||
                        selectedTags.includes(tags?.id)
                          ? "white"
                          : "black",
                      cursor: "pointer",
                    }}
                  >
                    {capitalizeFirstLetter(tags?.name)}
                  </p>
                ))}
            </div>
          </div>
        )}
        {selectedTeams?.length > 0 ? (
          <div className="teams_cont" style={{ padding: "0 20px" }}>
            <h4 className="heading">Teams</h4>
            <div className="teams_name responsive-teams-container" style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
              {selectedTeams?.map((teams) => (
                <p
                  onClick={() => handleTeamClick(teams)}
                  key={teams?.id}
                  style={{
                    cursor: "pointer",
                    borderRadius: "50px",
                    padding: "7px 15px",
                    whiteSpace: "nowrap",
                    background:
                      restItems?.accessible_teams?.find(
                        (t) => t?.id === teams?.id
                      ) || teamAdded.includes(teams.id)
                        ? "rgb(141 146 149)"
                        : "white",
                    border:
                      restItems?.accessible_teams?.find(
                        (t) => t?.id === teams?.id
                      ) || teamAdded.includes(teams.id)
                        ? "none"
                        : "1px solid rgb(211 211 211)",
                    color:
                      restItems?.accessible_teams?.find(
                        (t) => t?.id === teams?.id
                      ) || teamAdded.includes(teams?.id)
                        ? "white"
                        : "black",
                  }}
                >
                  {capitalizeFirstLetter(teams?.name)}
                </p>
              ))}
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
      <AttachmentList attachments={attachments} onDelete={handleDelete} />

      <div className="col-xl-6" style={{ padding: "0 10px" }}>
        {/* <label>Attachments</label> */}
        <div className="mt-2">
          <Button
            // variant="contained"
            component="label"
            className="text-primary"
            startIcon={<AttachFileIcon />}
          >
            Add attachment
            <input type="file" hidden multiple onChange={handleFileChange} />
          </Button>
          <Tooltip
            title="You can add attachments for the following file types: xls, pdf, csv, doc, jpg, png up to a maximum size of 15MB"
            arrow
          >
            <IconButton
              aria-label="info"
              style={{
                verticalAlign: "middle",
                marginLeft: "11px",
              }}
            >
              <InfoIcon />
            </IconButton>
          </Tooltip>
        </div>
      </div>

      {files.length > 0 && (
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: 1,
            mt: 2,
          }}
        >
          {files?.map((file, index) => (
            <Chip
              key={index}
              label={file.file_name}
              onDelete={handleDeleteFile(file)}
            />
          ))}
        </Box>
      )}
      <div className="save_button">
        <button
          className="btn btn-primary"
          onClick={saveButtonHandler}
          // disabled={!isSomethingAdded}
          // disabled={!permissions.includes("write")}
        >
          Save
        </button>
      </div>

      <Modal
        open={isContactCustomerHistoryVisible}
        onClose={closeContactCustomerHistoryModal}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <Box sx={{ ...style2, position: "absolute" }}>
          <IconButton
            aria-label="close"
            onClick={closeContactCustomerHistoryModal}
            sx={{
              position: "fixed",
              top: 16,
              right: 16,
              zIndex: 1301,
            }}
          >
            <GridCloseIcon />
          </IconButton>
          <Typography
            id="modal-title"
            variant="h6"
            component="h2"
            sx={{ mb: 2 }}
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            Customer history
          </Typography>

          <Box>
            <ContactCustomerHistory storingCustomerHistoryId={id} />
          </Box>
        </Box>
      </Modal>
    </div>
  );
};

export default ContactInfo;